import React from 'react'
import { useClientOptions, useUser } from '@paintscout/ui-business'
import { getFeature } from '@paintscout/util/builder'

export interface FeatureProps {
  required: Record<string, boolean | string | number>
  children: any
  isSuperAdmin?: boolean
}

/**
 * Only renders the children if the required features in $options are enabled
 */
export default function Feature({ children, required = {}, isSuperAdmin, ...other }: FeatureProps): JSX.Element {
  const { options } = useClientOptions()
  const { preferences } = useUser()
  if (!children) {
    return null
  }

  if (options || isSuperAdmin) {
    const hasAccess = Object.keys(required).reduce((result, feature) => {
      if (result) {
        const featureSetting = getFeature({ options, preferences, path: feature })

        if (featureSetting !== required[feature]) {
          return false
        }
      }

      return result
    }, true)

    return (
      hasAccess || isSuperAdmin
        ? Array.isArray(children)
          ? React.Children.map(children, (child) => React.cloneElement(child, other || {}))
          : React.cloneElement(children, other || {})
        : null
    ) as JSX.Element
  }

  return null
}
